import React, { useEffect } from 'react'
import SkillsBar from '../components/SkillsBar'
import aos from "aos"
import "aos/dist/aos.css"
const Service = () => {
  useEffect(()=>{
    aos.init({duration:3000});
    });
  return (
    <section className="services-area page-section scroll-to-page" id="services">
    <div className="custom-container">
      <div className="services-content content-width">
        <div className="section-header">
          <h4 className="subtitle scroll-animation" data-animation="fade_from_bottom">
            <i className="las la-stream" /> Skill Bar
          </h4>
          <h1 className="scroll-animation" data-aos="fade-up"
     data-aos-anchor-placement="top-bottom" data-animation="fade_from_bottom"  style={{fontWeight:"500",marginBottom:"24px"}}>My <span>Skill Bar</span></h1>
        </div>
        {/* <div className="services-items">
          <div className="service-item scroll-animation" data-animation="fade_from_bottom">
            <i className="las la-bezier-curve" />
            <h2>Website Design</h2>
            <p>I created digital products with unique ideas use Figma &amp; Framer</p>
            <span className="projects">24 Projects</span>
          </div>
          <div className="service-item scroll-animation" data-animation="fade_from_bottom">
            <i className="las la-code" />
            <h2>Development</h2>
            <p>I build website go live with Framer, Webflow or WordPress</p>
            <span className="projects">126 Projects</span>
          </div>
          <div className="service-item scroll-animation" data-animation="fade_from_bottom">
            <i className="las la-bezier-curve" />
            <h2>SEO/Marketing</h2>
            <p>Increase the traffic for your website with SEO optimized</p>
            <span className="projects">8 Projects</span>
          </div>
        </div> */}
        <SkillsBar />
      </div>
    </div>
  </section>
  )
}

export default Service